/**
 * 렌더 시작 전에 환경을 점검한다. 가장 흔한 실패 지점(WebGL 미지원)을
 * 사람이 읽을 수 있는 한국어 에러로 바꿔, #err 패널에 그대로 노출되게 한다.
 */
export function assertWebGLAvailable(): void {
  const canvas = document.createElement('canvas');
  const gl = canvas.getContext('webgl') ?? canvas.getContext('experimental-webgl');
  if (!gl) {
    throw new Error(
      '이 브라우저/환경에서 WebGL을 사용할 수 없음 (모바일 인앱 웹뷰에서 흔함). 데스크탑 브라우저에서 열어줘.',
    );
  }
}
